export const inIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export const escapeSingleQuotes = (str: string | null | undefined) => {
  return str ? str.replace(/'/g, "\\'") : '';
};
